<template>
  <div class="flex">
    <div v-for="(option, index) in options" :key="option.value">
      <button
        type="button"
        :ref="option.value + 'button'"
        :class="[
          paddingClass,
          fontSizeClass,
          leadingClass,
          colorClass,
          selectedClass(option.value),
          borderClass(index),
          'shadow-none font-sans inline-flex items-center justify-center transition ease-in-out duration-100 relative',
        ]"
        @click="handleClick(option.value)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: "ButtonToggleGroup",
  props: {
    options: Array,
    size: {
      type: String,
      default: "sm",
      validator: (value) => ["xs", "sm", "md", "lg", "xl"].indexOf(value) !== -1,
    },
    disabled: { type: Boolean, default: false },
    modelValue: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      currentSelectionValue: null,
    };
  },
  watch: {
    // Only watch value prop if it's provided
    modelValue: {
      handler(newVal) {
        if (newVal !== null && newVal !== undefined) {
          this.currentSelectionValue = newVal;
        }
      },
      immediate: true,
    },
  },
  computed: {
    paddingClass() {
      switch (this.size) {
        case "xs":
          return "px-2.5 py-1.5";
        case "sm":
          return "px-3 py-2";
        case "md":
        case "lg":
          return "px-4 py-2";
        case "xl":
          return "px-6 py-3";
        default:
          return "";
      }
    },
    fontSizeClass() {
      switch (this.size) {
        case "xs":
          return "text-xs";
        case "sm":
        case "md":
          return "text-sm";
        case "lg":
        case "xl":
          return "text-base";
      }
      return "";
    },
    leadingClass() {
      switch (this.size) {
        case "sm":
          return "leading-4";
      }
      return "";
    },
    colorClass() {
      if (this.disabled) {
        return "border-gray-300 text-gray-500 bg-gray-100 cursor-not-allowed";
      } else {
        return `border-gray-300 bg-white text-gray-600 hover:text-primary-700 focus:outline-none`;
      }
    },
  },
  methods: {
    isSelected(value) {
      return value === this.currentSelectionValue ? true : false;
    },
    selectedClass(value) {
      if (this.isSelected(value) === true) return `text-primary-700 bg-primary-100`;
      else return "";
    },
    borderClass(index) {
      if (index == 0) return "rounded-l border-l border-t border-b";
      else if (index == this.options.length - 1) return "rounded-r border-l-none rounded-l-none border";
      else return "border-t border-b border-l rounded-none";
    },
    handleClick(value) {
      this.currentSelectionValue = value;
      this.$emit("update:modelValue", value);
      this.$emit("selected", value);
    },
    clearSelection() {
      this.currentSelectionValue = null;
    },
  },
};
</script>
